// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-company-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .sa-company-form-container {
    padding: 1rem;
  }
}
.sa-company-form-container .sa-company-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: company-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .sa-company-form-container .sa-company-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.sa-company-form-container .sa-company-form-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.sa-company-form-container .sa-company-form-header .sa-company-form-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 0.5rem 0;
}
@media (max-width: 768px) {
  .sa-company-form-container .sa-company-form-header .sa-company-form-title {
    font-size: 1.25rem;
  }
}
.sa-company-form-container .sa-company-form-header .sa-company-form-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}
.sa-company-form-container .sa-company-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.sa-company-form-container .form-header {
  display: none;
}
.sa-company-form-container .company-form,
.sa-company-form-container .form-content {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form,
  .sa-company-form-container .form-content {
    padding: 0;
    width: 100%;
  }
}
.sa-company-form-container .company-form .form-section,
.sa-company-form-container .form-content .form-section {
  padding-bottom: 1.5rem;
}
.sa-company-form-container .company-form .form-section:last-of-type,
.sa-company-form-container .form-content .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.sa-company-form-container .company-form .form-section h3,
.sa-company-form-container .form-content .form-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.sa-company-form-container .company-form .form-grid,
.sa-company-form-container .form-content .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .form-grid,
  .sa-company-form-container .form-content .form-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group {
  display: flex;
  flex-direction: column;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.full-width,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.full-width {
  grid-column: 1/-1;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group label,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group label .required,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group label .required {
  color: #ef4444;
  margin-left: 0.25rem;
  font-size: 0.875rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input:focus,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:focus,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input:hover:not(:focus),
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:hover:not(:focus),
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea:hover:not(:focus),
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input:hover:not(:focus),
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:hover:not(:focus),
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input::placeholder,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select::placeholder,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea::placeholder,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input::placeholder,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select::placeholder,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea::placeholder {
  color: #9ca3af;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input:disabled,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:disabled,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:disabled {
  cursor: not-allowed;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select option,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select option {
  padding: 0.5rem;
  background: #ffffff;
  color: #374151;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea {
  resize: vertical;
  min-height: 4rem;
  padding: 0.5rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group .error,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group .error {
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  font-weight: 500;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle {
  flex-direction: column;
  gap: 0.75rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle label,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle label {
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle label .required,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle label .required {
  display: none;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple {
  position: relative;
  width: 48px;
  height: 24px;
  background-color: #d1d5db;
  border-radius: 12px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  border: none;
  padding: 0;
  min-height: auto;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple::before,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active {
  background-color: var(--primary-color);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active::before,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active::before {
  transform: translateX(24px);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .status-text,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .status-text {
  font-size: 0.75rem;
  color: #6b7280;
  margin-left: 0.5rem;
}
.sa-company-form-container .company-form .visibility-section .module-rights-header,
.sa-company-form-container .form-content .visibility-section .module-rights-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .visibility-section .module-rights-header,
  .sa-company-form-container .form-content .visibility-section .module-rights-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}
.sa-company-form-container .company-form .visibility-section h3,
.sa-company-form-container .form-content .visibility-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
.sa-company-form-container .company-form .visibility-section .override-toggle-container,
.sa-company-form-container .form-content .visibility-section .override-toggle-container {
  display: flex;
  align-items: center;
}
.sa-company-form-container .company-form .visibility-section .override-toggle-container .override-toggle-label,
.sa-company-form-container .form-content .visibility-section .override-toggle-container .override-toggle-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  margin: 0;
}
.sa-company-form-container .company-form .visibility-section .override-toggle-container .override-toggle-label .override-label-text,
.sa-company-form-container .form-content .visibility-section .override-toggle-container .override-toggle-label .override-label-text {
  -webkit-user-select: none;
          user-select: none;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-info,
.sa-company-form-container .company-form .visibility-section .plan-rights-info,
.sa-company-form-container .form-content .visibility-section .custom-rights-info,
.sa-company-form-container .form-content .visibility-section .plan-rights-info {
  background-color: #f3f4f6;
  border-left: 3px solid var(--primary-color, #3b82f6);
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-info p,
.sa-company-form-container .company-form .visibility-section .plan-rights-info p,
.sa-company-form-container .form-content .visibility-section .custom-rights-info p,
.sa-company-form-container .form-content .visibility-section .plan-rights-info p {
  margin: 0;
  font-size: 0.875rem;
  color: #4b5563;
}
.sa-company-form-container .company-form .visibility-section .loading-rights,
.sa-company-form-container .form-content .visibility-section .loading-rights {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 0.875rem;
}
.sa-company-form-container .company-form .visibility-section .visibility-toggles,
.sa-company-form-container .form-content .visibility-section .visibility-toggles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .visibility-section .visibility-toggles,
  .sa-company-form-container .form-content .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions,
.sa-company-form-container .form-content .visibility-section .custom-rights-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights,
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color, #3b82f6);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights:hover:not(:disabled),
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights:hover:not(:disabled) {
  background-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights:active:not(:disabled),
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights:active:not(:disabled) {
  transform: translateY(0);
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights:disabled,
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights,
  .sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights {
    width: 100%;
  }
}
.sa-company-form-container .company-form .visibility-section .toggle-label,
.sa-company-form-container .form-content .visibility-section .toggle-label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  text-transform: capitalize;
  margin-bottom: 0;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch,
.sa-company-form-container .form-content .visibility-section .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: pointer;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input,
.sa-company-form-container .form-content .visibility-section .toggle-switch input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input:checked + .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch input:checked + .slider {
  background-color: var(--primary-color, #3b82f6);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input:checked + .slider::before,
.sa-company-form-container .form-content .visibility-section .toggle-switch input:checked + .slider::before {
  transform: translateX(26px);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input:focus + .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch input:focus + .slider {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch .slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: all 0.3s ease;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch .slider::before,
.sa-company-form-container .form-content .visibility-section .toggle-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch:hover .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch:hover .slider {
  background-color: #9ca3af;
}
input:checked + .sa-company-form-container .company-form .visibility-section .toggle-switch:hover .slider,
input:checked + .sa-company-form-container .form-content .visibility-section .toggle-switch:hover .slider {
  background-color: #2563eb;
}
.sa-company-form-container .company-form .form-actions,
.sa-company-form-container .form-content .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .form-actions,
  .sa-company-form-container .form-content .form-actions {
    flex-direction: column;
  }
}
.sa-company-form-container .company-form .form-actions .btn-submit,
.sa-company-form-container .form-content .form-actions .btn-submit {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .form-actions .btn-submit,
  .sa-company-form-container .form-content .form-actions .btn-submit {
    width: 100%;
  }
}
.sa-company-form-container .company-form .form-actions .btn-submit:disabled,
.sa-company-form-container .form-content .form-actions .btn-submit:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.sa-company-form-container .company-form .form-actions .btn-cancel,
.sa-company-form-container .form-content .form-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.sa-company-form-container .company-form .form-actions .btn-cancel:hover,
.sa-company-form-container .form-content .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.sa-company-form-container .company-form .form-actions .btn-submit,
.sa-company-form-container .form-content .form-actions .btn-submit {
  background-color: var(--primary-color);
  color: white;
}
.sa-company-form-container .company-form .form-actions .btn-submit:hover,
.sa-company-form-container .form-content .form-actions .btn-submit:hover {
  background-color: #005a9a;
}
.sa-company-form-container .company-form .form-actions .btn-submit:focus,
.sa-company-form-container .form-content .form-actions .btn-submit:focus {
  outline: none;
}
.sa-company-form-container .company-form .form-actions .btn-submit.disabled, .sa-company-form-container .company-form .form-actions .btn-submit:disabled,
.sa-company-form-container .form-content .form-actions .btn-submit.disabled,
.sa-company-form-container .form-content .form-actions .btn-submit:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.sa-company-form-container .loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 70%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .sa-company-form-container .loading {
    width: 100%;
  }
}
.sa-company-form-container .loading-rights {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 0.875rem;
  font-style: italic;
}

@keyframes company-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .sa-company-form-container .sa-company-form-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .sa-company-form-container {
    padding: 0.5rem;
  }
  .sa-company-form-container .sa-company-form-wrapper {
    padding: 0.75rem;
  }
  .sa-company-form-container .sa-company-form-header .sa-company-form-title {
    font-size: 1.125rem;
  }
  .sa-company-form-container .sa-company-form-header .sa-company-form-subtitle {
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .form-grid,
  .sa-company-form-container .form-content .form-grid {
    gap: 0.5rem;
  }
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group label,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group label {
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group input,
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group select,
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group input,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group select,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .form-actions .btn-cancel,
  .sa-company-form-container .company-form .form-actions .btn-submit,
  .sa-company-form-container .form-content .form-actions .btn-cancel,
  .sa-company-form-container .form-content .form-actions .btn-submit {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .visibility-section .visibility-toggles,
  .sa-company-form-container .form-content .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.5rem;
  }
}
@media print {
  .sa-company-form-container {
    background: white;
    padding: 0;
  }
  .sa-company-form-container .sa-company-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .sa-company-form-container .form-actions {
    display: none;
  }
}
.sa-company-form-container input:focus-visible,
.sa-company-form-container select:focus-visible,
.sa-company-form-container textarea:focus-visible,
.sa-company-form-container button:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}
.sa-company-form-container .toggle-switch input:focus-visible + .slider {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}
.sa-company-form-container .readonly-field {
  background-color: #f5f5f5 !important;
  cursor: not-allowed !important;
  opacity: 0.7;
  color: #6b7280;
}
.sa-company-form-container .readonly-field:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
.sa-company-form-container .readonly-field:hover {
  border-color: #d1d5db !important;
}`, "",{"version":3,"sources":["webpack://./src/forms/SACompanyForm/SACompanyForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,aAAA;EACF;AACF;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,6CAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,WAAA;EACJ;AACF;AAGE;EACE,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAGI;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AADN;AAME;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAJJ;AAQE;EACE,aAAA;AANJ;AAUE;;EAEE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AARJ;AAUI;EATF;;IAUI,UAAA;IACA,WAAA;EANJ;AACF;AASI;;EAEE,sBAAA;AAPN;AAUM;;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AAUM;;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAPR;AAYI;;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AATN;AAYM;EANF;;IAOI,0BAAA;IACA,WAAA;EARN;AACF;AAUM;;EACE,aAAA;EACA,sBAAA;AAPR;AASQ;;EACE,iBAAA;AANV;AASQ;;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AANV;AAQU;;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;AALZ;AAUQ;;;;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AALV;AAOU;;;;;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AAAZ;AAGU;;;;;;EACE,qBAAA;AAIZ;AADU;;;;;;EACE,cAAA;AAQZ;AALU;;;;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAYZ;AARQ;;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AAWV;AATU;;EACE,mBAAA;AAYZ;AATU;;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAYZ;AARQ;;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AAWV;AARQ;;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAWV;AAPM;;EACE,sBAAA;EACA,YAAA;AAUR;AAPQ;;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAUV;AARU;;EACE,aAAA;AAWZ;AAPQ;;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAUV;AARU;;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,wCAAA;AAWZ;AARU;;EACE,sCAAA;AAWZ;AATY;;EACE,2BAAA;AAYd;AARU;;EACE,0BAAA;EACA,mBAAA;AAWZ;AARU;;EACE,YAAA;EACA,mBAAA;AAWZ;AAPQ;;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AAUV;AAHM;;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAMR;AAJQ;EARF;;IASI,sBAAA;IACA,uBAAA;IACA,SAAA;EAQR;AACF;AALM;;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAQR;AALM;;EACE,aAAA;EACA,mBAAA;AAQR;AANQ;;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AASV;AAPU;;EACE,yBAAA;UAAA,iBAAA;AAUZ;AALM;;;;EAEE,yBAAA;EACA,oDAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AASR;AAPQ;;;;EACE,SAAA;EACA,mBAAA;EACA,cAAA;AAYV;AARM;;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAWR;AARM;;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAWR;AATQ;EANF;;IAOI,4DAAA;IACA,YAAA;EAaR;AACF;AAVM;;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAaR;AAXQ;;EACE,uBAAA;EACA,+CAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAcV;AAZU;;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AAeZ;AAZU;;EACE,wBAAA;AAeZ;AAZU;;EACE,YAAA;EACA,mBAAA;AAeZ;AAZU;EA1BF;;IA2BI,WAAA;EAgBV;AACF;AAZM;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;AAeR;AAZM;;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAeR;AAbQ;;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAgBV;AAdU;;EACE,+CAAA;AAiBZ;AAfY;;EACE,2BAAA;AAkBd;AAdU;;EACE,6CAAA;AAiBZ;AAbQ;;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAgBV;AAdU;;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAiBZ;AAbQ;;EACE,yBAAA;AAgBV;AAdU;;EACE,yBAAA;AAiBZ;AAVI;;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAaN;AAXM;EAPF;;IAQI,sBAAA;EAeN;AACF;AAZM;;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAeR;AAbQ;EAdF;;IAeI,WAAA;EAiBR;AACF;AAfQ;;EACE,mBAAA;EACA,YAAA;AAkBV;AAdM;;EAiBE,iBAAA;EACF,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AACN;AACM;;EACE,yBAAA;AAER;AAEM;;EACE,sCAAA;EACA,YAAA;AACR;AAIQ;;EACE,yBAAA;AADV;AAIQ;;EACE,aAAA;AADV;AAIQ;;;EAEE,yBAAA;EACA,cAAA;AADV;AAsBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;AApBJ;AAsBI;EAXF;IAYI,WAAA;EAnBJ;AACF;AAsBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AApBJ;;AAyBA;EACE;IACE,UAAA;IACA,2BAAA;EAtBF;EAyBA;IACE,UAAA;IACA,wBAAA;EAvBF;AACF;AA0BA;EACE;IACE,uBAAA;EAxBF;EA2BA;IACE,yBAAA;EAzBF;AACF;AA6BA;EAEI;IACE,WAAA;EA5BJ;AACF;AAgCA;EACE;IACE,eAAA;EA9BF;EAgCE;IACE,gBAAA;EA9BJ;EAkCI;IACE,mBAAA;EAhCN;EAmCI;IACE,oBAAA;EAjCN;EAuCI;;IACE,WAAA;EApCN;EAuCQ;;IACE,oBAAA;EApCV;EAuCQ;;;;;;IAGE,iBAAA;IACA,oBAAA;EAlCV;EAyCM;;;;IAEE,oBAAA;IACA,oBAAA;EArCR;EA0CM;;IACE,4DAAA;IACA,WAAA;EAvCR;AACF;AA8CA;EACE;IACE,iBAAA;IACA,UAAA;EA5CF;EA8CE;IACE,gBAAA;IACA,sBAAA;EA5CJ;EA+CE;IACE,aAAA;EA7CJ;AACF;AAoDE;;;;EAIE,gDAAA;EACA,mBAAA;AAlDJ;AAqDE;EACE,gDAAA;EACA,mBAAA;AAnDJ;AAuDE;EACE,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;AArDJ;AAuDI;EACE,wBAAA;EACA,2BAAA;EACA,gCAAA;AArDN;AAwDI;EACE,gCAAA;AAtDN","sourcesContent":["// Main Container\r\n.sa-company-form-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  // Form Wrapper - New wrapper structure\r\n  .sa-company-form-wrapper {\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    animation: company-form-fade-in 0.3s ease-out;\r\n    width: 70%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  // Header styling (moved inside wrapper)\r\n  .sa-company-form-header {\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n    .sa-company-form-title {\r\n      font-size: 1.6rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 0.5rem 0;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n\r\n    .sa-company-form-subtitle {\r\n      font-size: 0.875rem;\r\n      color: #6b7280;\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  // Divider styling\r\n  .sa-company-form-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Hide old form header (if any remains)\r\n  .form-header {\r\n    display: none;\r\n  }\r\n\r\n  // Form styling - Updated to work with wrapper\r\n  .company-form,\r\n  .form-content {\r\n    padding: 0; // Remove padding since it's now in wrapper\r\n    background: transparent;\r\n    border: none;\r\n    box-shadow: none;\r\n    animation: none;\r\n    width: 100%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0;\r\n      width: 100%;\r\n    }\r\n\r\n    // Form sections\r\n    .form-section {\r\n      //margin-bottom: 1.5rem;\r\n      padding-bottom: 1.5rem;\r\n      // border-bottom: 1px solid #f3f4f6;\r\n\r\n      &:last-of-type {\r\n        border-bottom: none;\r\n        margin-bottom: 0;\r\n        padding-bottom: 0;\r\n      }\r\n\r\n      h3 {\r\n        font-size: 1.125rem;\r\n        font-weight: 500;\r\n        color: #374151;\r\n        margin: 0 0 1rem 0;\r\n        padding-bottom: 0.5rem;\r\n        border-bottom: 1px solid #e5e7eb;\r\n      }\r\n    }\r\n\r\n    // Form grid for company details\r\n    .form-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 1rem;\r\n      // margin-bottom: 1.5rem;\r\n\r\n      @media (max-width: 768px) {\r\n        grid-template-columns: 1fr;\r\n        gap: 0.5rem;\r\n      }\r\n\r\n      .sa-comp-form-group {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        &.full-width {\r\n          grid-column: 1 / -1;\r\n        }\r\n\r\n        label {\r\n          display: block;\r\n          margin-bottom: 0.5rem;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          color: #374151;\r\n\r\n          .required {\r\n            color: #ef4444;\r\n            margin-left: 0.25rem;\r\n            font-size: 0.875rem;\r\n          }\r\n        }\r\n\r\n        // Input styling to match UserForm\r\n        input,\r\n        select,\r\n        textarea {\r\n          width: 100%;\r\n          padding: 0.5rem;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 0.25rem;\r\n          font-size: 0.875rem;\r\n          font-family: inherit;\r\n          color: #374151;\r\n          background: #ffffff;\r\n          box-sizing: border-box;\r\n          min-height: 2.5rem;\r\n\r\n          &:focus {\r\n            outline: none;\r\n            border-color: var(--primary-color, #3b82f6);\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n\r\n          &:hover:not(:focus) {\r\n            border-color: #9ca3af;\r\n          }\r\n\r\n          &::placeholder {\r\n            color: #9ca3af;\r\n          }\r\n\r\n          &:disabled {\r\n            background-color: #f9fafb;\r\n            color: #6b7280;\r\n            cursor: not-allowed;\r\n          }\r\n        }\r\n\r\n        select {\r\n          appearance: none;\r\n          background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n          background-position: right 0.5rem center;\r\n          background-repeat: no-repeat;\r\n          background-size: 1.5rem 1.5rem;\r\n          padding-right: 2.5rem;\r\n          cursor: pointer;\r\n\r\n          &:disabled {\r\n            cursor: not-allowed;\r\n          }\r\n\r\n          option {\r\n            padding: 0.5rem;\r\n            background: #ffffff;\r\n            color: #374151;\r\n          }\r\n        }\r\n\r\n        textarea {\r\n          resize: vertical;\r\n          min-height: 4rem;\r\n          padding: 0.5rem;\r\n        }\r\n\r\n        .error {\r\n          color: #ef4444;\r\n          font-size: 0.75rem;\r\n          margin-top: 0.25rem;\r\n          font-weight: 500;\r\n        }\r\n      }\r\n\r\n      .sa-comp-form-group.company-status-toggle {\r\n        flex-direction: column;\r\n        gap: 0.75rem;\r\n        // margin-bottom: 1.5rem;\r\n\r\n        label {\r\n          margin-bottom: 0;\r\n          cursor: pointer;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          color: #374151;\r\n\r\n          .required {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        .toggle-switch-simple {\r\n          position: relative;\r\n          width: 48px;\r\n          height: 24px;\r\n          background-color: #d1d5db;\r\n          border-radius: 12px;\r\n          transition: background-color 0.2s ease;\r\n          cursor: pointer;\r\n          border: none;\r\n          padding: 0;\r\n          min-height: auto;\r\n\r\n          &::before {\r\n            content: '';\r\n            position: absolute;\r\n            top: 2px;\r\n            left: 2px;\r\n            width: 20px;\r\n            height: 20px;\r\n            background-color: white;\r\n            border-radius: 50%;\r\n            transition: transform 0.2s ease;\r\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n          }\r\n\r\n          &.active {\r\n            background-color: var(--primary-color);\r\n\r\n            &::before {\r\n              transform: translateX(24px);\r\n            }\r\n          }\r\n\r\n          &:focus {\r\n            outline: 2px solid #3b82f6;\r\n            outline-offset: 2px;\r\n          }\r\n\r\n          &:disabled {\r\n            opacity: 0.5;\r\n            cursor: not-allowed;\r\n          }\r\n        }\r\n\r\n        .status-text {\r\n          font-size: 0.75rem;\r\n          color: #6b7280;\r\n          margin-left: 0.5rem;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Visibility section styling\r\n    .visibility-section {\r\n      .module-rights-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-bottom: 1rem;\r\n        padding-bottom: 0.75rem;\r\n        border-bottom: 1px solid #e5e7eb;\r\n\r\n        @media (max-width: 768px) {\r\n          flex-direction: column;\r\n          align-items: flex-start;\r\n          gap: 1rem;\r\n        }\r\n      }\r\n\r\n      h3 {\r\n        font-size: 1.125rem;\r\n        font-weight: 500;\r\n        color: #374151;\r\n        margin: 0;\r\n      }\r\n\r\n      .override-toggle-container {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        .override-toggle-label {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 0.75rem;\r\n          font-size: 0.875rem;\r\n          font-weight: 500;\r\n          color: #374151;\r\n          cursor: pointer;\r\n          margin: 0;\r\n\r\n          .override-label-text {\r\n            user-select: none;\r\n          }\r\n        }\r\n      }\r\n\r\n      .custom-rights-info,\r\n      .plan-rights-info {\r\n        background-color: #f3f4f6;\r\n        border-left: 3px solid var(--primary-color, #3b82f6);\r\n        padding: 0.75rem 1rem;\r\n        margin-bottom: 1rem;\r\n        border-radius: 0.375rem;\r\n\r\n        p {\r\n          margin: 0;\r\n          font-size: 0.875rem;\r\n          color: #4b5563;\r\n        }\r\n      }\r\n\r\n      .loading-rights {\r\n        text-align: center;\r\n        padding: 2rem;\r\n        color: #6b7280;\r\n        font-size: 0.875rem;\r\n      }\r\n\r\n      .visibility-toggles {\r\n        display: grid;\r\n        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n        gap: 1rem;\r\n        margin-top: 1rem;\r\n\r\n        @media (max-width: 768px) {\r\n          grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n          gap: 0.75rem;\r\n        }\r\n      }\r\n\r\n      .custom-rights-actions {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        margin-top: 1.5rem;\r\n        padding-top: 1rem;\r\n        border-top: 1px solid #e5e7eb;\r\n\r\n        .btn-save-custom-rights {\r\n          padding: 0.75rem 1.5rem;\r\n          background-color: var(--primary-color, #3b82f6);\r\n          color: white;\r\n          border: none;\r\n          border-radius: 0.375rem;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n\r\n          &:hover:not(:disabled) {\r\n            background-color: #2563eb;\r\n            transform: translateY(-1px);\r\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n          }\r\n\r\n          &:active:not(:disabled) {\r\n            transform: translateY(0);\r\n          }\r\n\r\n          &:disabled {\r\n            opacity: 0.6;\r\n            cursor: not-allowed;\r\n          }\r\n\r\n          @media (max-width: 768px) {\r\n            width: 100%;\r\n          }\r\n        }\r\n      }\r\n\r\n      .toggle-label {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 0.5rem;\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        color: #374151;\r\n        text-transform: capitalize;\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      .toggle-switch {\r\n        position: relative;\r\n        width: 50px;\r\n        height: 24px;\r\n        cursor: pointer;\r\n\r\n        input {\r\n          opacity: 0;\r\n          position: absolute;\r\n          width: 0;\r\n          height: 0;\r\n\r\n          &:checked+.slider {\r\n            background-color: var(--primary-color, #3b82f6);\r\n\r\n            &::before {\r\n              transform: translateX(26px);\r\n            }\r\n          }\r\n\r\n          &:focus+.slider {\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n        }\r\n\r\n        .slider {\r\n          position: absolute;\r\n          top: 0;\r\n          left: 0;\r\n          right: 0;\r\n          bottom: 0;\r\n          background-color: #d1d5db;\r\n          border-radius: 24px;\r\n          transition: all 0.3s ease;\r\n\r\n          &::before {\r\n            content: '';\r\n            position: absolute;\r\n            height: 18px;\r\n            width: 18px;\r\n            left: 3px;\r\n            top: 3px;\r\n            background-color: white;\r\n            border-radius: 50%;\r\n            transition: all 0.3s ease;\r\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n          }\r\n        }\r\n\r\n        &:hover .slider {\r\n          background-color: #9ca3af;\r\n\r\n          input:checked+& {\r\n            background-color: #2563eb;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Form actions\r\n    .form-actions {\r\n      display: flex;\r\n      justify-content: end;\r\n      gap: 1rem;\r\n      padding-top: 1rem;\r\n      border-top: 1px solid #e5e7eb;\r\n\r\n      @media (max-width: 768px) {\r\n        flex-direction: column;\r\n      }\r\n\r\n      \r\n      .btn-submit {\r\n        padding: 0.75rem 1.5rem;\r\n        border: none;\r\n        border-radius: 0.375rem;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        cursor: pointer;\r\n        min-width: 120px;\r\n        transition: all 0.2s ease;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 0.5rem;\r\n\r\n        @media (max-width: 768px) {\r\n          width: 100%;\r\n        }\r\n\r\n        &:disabled {\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n        }\r\n      }\r\n\r\n      .btn-cancel {\r\n        // background-color: #dc2626;\r\n        // color: white;\r\n\r\n        // &:hover:not(:disabled) {\r\n        //   background-color: #b91c1c;\r\n        // }\r\n\r\n        // &:focus {\r\n        //   outline: none;\r\n        //   box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n        // }\r\n\r\n        // &:disabled {\r\n        //   background-color: #d1d5db;\r\n        //   color: #9ca3af;\r\n        // }\r\n        padding: 8px 16px;\r\n      border: 1px solid #ddd;\r\n      background: white;\r\n      color: #666;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      font-size: 14px;\r\n\r\n      &:hover {\r\n        background-color: #f8f9fa;\r\n      }\r\n      }\r\n\r\n      .btn-submit {\r\n        background-color: var(--primary-color);\r\n        color: white;\r\n\r\n        // &:hover:not(:disabled):not(.submitting) {\r\n        //   background-color: #15803d;\r\n        // }\r\n        &:hover{\r\n          background-color: #005a9a;\r\n        }\r\n\r\n        &:focus {\r\n          outline: none;\r\n        }\r\n\r\n        &.disabled,\r\n        &:disabled {\r\n          background-color: #d1d5db;\r\n          color: #9ca3af;\r\n        }\r\n\r\n        // &.submitting {\r\n        //   background-color: #16a34a;\r\n        //   cursor: not-allowed;\r\n\r\n        //   .spinner {\r\n        //     width: 1rem;\r\n        //     height: 1rem;\r\n        //     border: 2px solid transparent;\r\n        //     border-top: 2px solid white;\r\n        //     border-radius: 50%;\r\n        //     animation: spin 1s linear infinite;\r\n        //   }\r\n        // }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Loading state\r\n  .loading {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 200px;\r\n    width: 70%;\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 0.375rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n\r\n    @media (max-width: 768px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .loading-rights {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 2rem;\r\n    color: #6b7280;\r\n    font-size: 0.875rem;\r\n    font-style: italic;\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes company-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 768px) {\r\n  .sa-company-form-container {\r\n    .sa-company-form-wrapper {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .sa-company-form-container {\r\n    padding: 0.5rem;\r\n\r\n    .sa-company-form-wrapper {\r\n      padding: 0.75rem;\r\n    }\r\n\r\n    .sa-company-form-header {\r\n      .sa-company-form-title {\r\n        font-size: 1.125rem;\r\n      }\r\n\r\n      .sa-company-form-subtitle {\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n\r\n    .company-form,\r\n    .form-content {\r\n      .form-grid {\r\n        gap: 0.5rem;\r\n\r\n        .sa-comp-form-group {\r\n          label {\r\n            font-size: 0.8125rem;\r\n          }\r\n\r\n          input,\r\n          select,\r\n          textarea {\r\n            padding: 0.375rem;\r\n            font-size: 0.8125rem;\r\n          }\r\n        }\r\n      }\r\n\r\n      .form-actions {\r\n\r\n        .btn-cancel,\r\n        .btn-submit {\r\n          padding: 0.5rem 1rem;\r\n          font-size: 0.8125rem;\r\n        }\r\n      }\r\n\r\n      .visibility-section {\r\n        .visibility-toggles {\r\n          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n          gap: 0.5rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .sa-company-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .sa-company-form-wrapper {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .form-actions {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Focus visible improvements for accessibility\r\n.sa-company-form-container {\r\n\r\n  input:focus-visible,\r\n  select:focus-visible,\r\n  textarea:focus-visible,\r\n  button:focus-visible {\r\n    outline: 2px solid var(--primary-color, #3b82f6);\r\n    outline-offset: 2px;\r\n  }\r\n\r\n  .toggle-switch input:focus-visible+.slider {\r\n    outline: 2px solid var(--primary-color, #3b82f6);\r\n    outline-offset: 2px;\r\n  }\r\n\r\n  // Readonly field styles\r\n  .readonly-field {\r\n    background-color: #f5f5f5 !important;\r\n    cursor: not-allowed !important;\r\n    opacity: 0.7;\r\n    color: #6b7280;\r\n\r\n    &:focus {\r\n      outline: none !important;\r\n      box-shadow: none !important;\r\n      border-color: #d1d5db !important;\r\n    }\r\n\r\n    &:hover {\r\n      border-color: #d1d5db !important;\r\n    }\r\n  }\r\n\r\n//   // Ensure subscription fields have consistent styling\r\n//   .form-section {\r\n//     input[name^=\"subscription.\"] {\r\n//       background-color: #ffffff !important;\r\n//       color: #374151 !important;\r\n      \r\n//       &:autofill,\r\n//       &:-webkit-autofill,\r\n//       &:-webkit-autofill:hover,\r\n//       &:-webkit-autofill:focus,\r\n//       &:-webkit-autofill:active {\r\n//         -webkit-box-shadow: 0 0 0 30px #ffffff inset !important;\r\n//         -webkit-text-fill-color: #374151 !important;\r\n//         background-color: #ffffff !important;\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
